const _import = file => () => import('@/views/' + file + '.vue')

export default [
    {//学校概况
        path: '/kitchenManage/school',
        name: 'school',
        component: _import('school/index')
    },
    {
        path: '/kitchenManage/schoolEdit',
        name: 'schoolEdit',
        component: _import('school/edit')
    },
    {//人员管理
        path: '/kitchenManage/person',
        name: 'person',
        component: _import('person/personList')
    },
    {
        path: '/kitchenManage/person/add',
        name: 'person.addAndEdit',
        component: _import('person/personAdd')
    },
    {
        path: '/kitchenManage/person/detail',
        name: 'person.detail',
        component: _import('person/personDetail')
    },
    {//每日菜谱
        path: '/kitchenManage/menu',
        name: 'menu',
        component: _import('menu/menuList')
    },
    {//晨检
        path: '/kitchenManage/inspect',
        name: 'inspect',
        component: _import('inspect/inspectList')
    },
    {
        path: '/kitchenManage/inspect/add',
        name: 'inspect.add',
        component: _import('inspect/inspectAdd')
    },
    {
        path: '/kitchenManage/inspect/edit',
        name: 'inspect.edit',
        component: _import('inspect/inspectEdit')
    },
    {
        path: '/kitchenManage/inspect/detail',
        name: 'inspect.detail',
        component: _import('inspect/inspectDetail')
    },
    {//清洗消毒
        path: '/kitchenManage/clean',
        name: 'clean',
        component: _import('clean/cleanList')
    },
    {//食品留样
        path: '/kitchenManage/reserved',
        name: 'reserved',
        component: _import('reserved/reservedList')
    },
    {//校长陪餐
        path: '/kitchenManage/accompany',
        name: 'accompany',
        component: _import('accompany/accompanyList')
    },
    {//餐厨垃圾
        path: '/kitchenManage/trash',
        name: 'trash',
        component: _import('trash/trashList')
    },
    { //培训记录
        path: '/kitchenManage/training',
        name: 'training',
        component: _import('training/trainingList')
    },
    {//配置中心
        path: '/kitchenManage/setting',
        name: 'setting',
        component: _import('setting/setting')
    },
    {//白名单管理
        path: '/kitchenManage/whiteList',
        name: 'whiteList',
        component: _import('wlManage/wlList')
    },
    {//就餐人员管理
        path: '/kitchenManage/mealPersonnel',
        name: 'mealPersonnel',
        component: _import('mealPersonnel/index')
    },

    {//家长访问审核
        path: '/kitchenManage/viewAudit',
        name: 'viewAudit',
        component: _import('viewAudit/auditList')
    },
    {//投诉反馈
        path: '/kitchenManage/feedback',
        name: 'feedback',
        component: _import('feedback/index')
    },
    {//规章制度
        path: '/kitchenManage/regulation',
        name: 'regulation',
        component: _import('regulation/regulationList')
    },
    {
        path: '/kitchenManage/regulation/add',
        name: 'regulation.addAndEdit',
        component: _import('regulation/regulationAdd')
    },
    {
        path: '/kitchenManage/regulation/detail',
        name: 'regulation.detail',
        component: _import('regulation/regulationDetail')
    },
    { // 索票索证
        path: '/kitchenManage/ticket',
        name: 'ticket',
        component: _import('ticket/ticket')
    },
    { //评价管理
        path: '/kitchenManage/commentManage',
        name: 'comment',
        component: _import('commentManage/manage')
    },
    { //子食堂管理
        path: '/kitchenManage/subCanteen',
        name: 'subCanteen',
        component: _import('subCanteen/subCanteenList')
    }
]